module.exports = __webpack_public_path__ + "e9aa694e2ee89888b852999ef45f3905.svg";